'use strict';

const getSubscriptionOffer = require('od-modules/helpers/membership/get_subscription_offer');

module.exports = Backbone.Model.extend({
    connect: true,
    selectors: ['primeStatus'],
    defaults: {
        isUserLoggedIn: false,
        isPrimePriceSelected: false,
        primeStatus: {},
        state: '',
    },
    url() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(getSubscriptionOffer.getUrl());
    },
    getSubscriptionPrice() {
        const {price} = this.getMembershipSubscriptionOfferDTO() || {};
        return price || 0;
    },
    requestSuccessHandler(model, data) {
        if (!data.error) {
            return data;
        }
    },
    getMembershipSubscriptionOfferDTO() {
        const {membershipSubscriptionOfferDTO} = this.getMembershipSubscriptionDetails() || {};
        return membershipSubscriptionOfferDTO;
    },
    getDataRequestSettings() {
        return {
            dataType: 'json',
            contentType: 'application/json',
            type: getSubscriptionOffer.getMethod(),
            success: Odigeo._.bind(this.requestSuccessHandler, this),
        };
    },
    getSubscriptionOffer() {
        return this.fetch(this.getDataRequestSettings());
    },
    getMembershipSubscriptionDetails() {
        const {membershipSubscriptionDetails} = this.get('primeStatus');
        return membershipSubscriptionDetails;
    },
    getMembershipRenewalPrice() {
        const {membershipSubscriptionDetails: membershipSubscriptionDetails} = this.get('primeStatus');
        return membershipSubscriptionDetails && membershipSubscriptionDetails.membershipSubscriptionOfferDTO.renewalPrice;
    },
    loginDone() {
        this.set('isUserLoggedIn', true);
    },
    logoutDone() {
        this.set('isUserLoggedIn', false);
    },
});
